import { Routes } from "@angular/router";
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';
import { QuestionListComponent } from "./component/question-list/question-list.component";
import { AddQuestionComponent } from "./component/add-question/add-question.component";
import { QuestionDetailsComponent } from "./component/question-details/question-details.component";
import { QuestionBankListComponent } from "./component/question-bank-list/question-bank-list.component";
import { QuestionBankDetailsComponent } from "./component/question-bank-details/question-bank-details.component";
import { AddQuestionBankComponent } from "./component/add-question-bank/add-question-bank.component";

export const QUESTION_ROUTES: Routes = [
	{
		path: 'question',
		component: LayoutComponent,
		canActivate: [MsalGuard],
		children: [
            { path: '', component: QuestionListComponent },
            { path: 'add', component: AddQuestionComponent },
            { path: 'add/:id', component: AddQuestionComponent },
            { path: 'questionbank', component: QuestionBankListComponent },
            { path: 'questionbank/add', component: AddQuestionBankComponent },
            { path: 'questionbank/:id', component: QuestionBankDetailsComponent },
            { path: ':id', component: QuestionDetailsComponent }
		]
	}
];
